import { ColorConverter, ObjectCreator } from "../../../../../../../../web-graphics";
import { SettingsParser } from "../../../settings-parser";
import { SimpleVisualizatorSettings } from "../../../../settings/simple-visualizator-settings";

export class ColoredPlotContentParser extends SettingsParser {
  constructor() {
    super();
  }

  static createSettings(settings, defaultSettings) {
    if (settings === undefined) {
      if (defaultSettings !== undefined) {
        return ObjectCreator.deepCopy(defaultSettings);
      }
      return undefined;
    }
    let parsedSettings = ObjectCreator.merge(settings, defaultSettings);
    if (parsedSettings.color !== undefined) {
      let parsedColor = ColorConverter.convertToWebglRgba(parsedSettings.color);
      parsedSettings.color = parsedColor.value;
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = ColoredPlotContentParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    return new SimpleVisualizatorSettings(parsedSettings);
  }
}
